import React from "react";
import { ArrowUpRight } from "lucide-react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useContent } from "../context/ContentContext";
import { external } from "../lib/links";
import { scrollToId } from "../lib/scroll";

export const Footer = () => {
  const { content } = useContent();
  const f = content.footer;
  const nav = content.nav || [];
  const links = content.links;
  const blogEnabled = content.blogPage?.enabled !== false;
  const blogLabel = content.blogPage?.navLabel || "Blog";
  const navigate = useNavigate();
  const location = useLocation();

  const goSection = (id) => {
    if (location.pathname !== "/") {
      sessionStorage.setItem("kb_scroll", id);
      navigate("/");
    } else {
      scrollToId(id);
    }
  };

  return (
    <footer data-testid="site-footer" className="relative bg-ink text-cream/80 pt-20 pb-10 overflow-hidden">
      <div className="grain absolute inset-0" />
      <div className="relative mx-auto max-w-7xl px-5 md:px-8">
        <div className="grid md:grid-cols-12 gap-12 pb-16 border-b border-white/10">
          <div className="md:col-span-5">
            <p className="font-serif text-4xl md:text-5xl text-cream leading-tight">
              {f.taglineLead}<span className="italic text-peach">{f.taglineAccent}</span>.
            </p>
            <a data-testid="footer-book-btn" href={links.janeBook} {...external} className="mt-8 inline-flex items-center gap-2 rounded-full bg-sage text-white px-8 py-4 font-semibold transition-[background-color,transform] duration-300 hover:bg-sage-dark hover:-translate-y-0.5">
              {f.cta} <ArrowUpRight className="h-4 w-4" />
            </a>
          </div>

          <div className="md:col-span-3 md:col-start-8">
            <p className="text-xs uppercase tracking-[0.22em] text-cream/50 mb-5">Explore</p>
            <ul className="space-y-3">
              {nav.map((l) => (
                <li key={l.id}>
                  <button data-testid={`footer-nav-${l.id}`} onClick={() => goSection(l.id)} className="text-cream/70 hover:text-peach transition-colors duration-300">{l.label}</button>
                </li>
              ))}
              {blogEnabled && (
                <li><Link data-testid="footer-nav-blog" to="/blog" className="text-cream/70 hover:text-peach transition-colors duration-300">{blogLabel}</Link></li>
              )}
            </ul>
          </div>

          <div className="md:col-span-2">
            <p className="text-xs uppercase tracking-[0.22em] text-cream/50 mb-5">Get started</p>
            <ul className="space-y-3">
              <li><a data-testid="footer-consult-link" href={links.janeConsult} {...external} className="text-cream/70 hover:text-peach transition-colors duration-300">Free 20-min consult</a></li>
              <li className="text-cream/70">Tsawwassen, Delta BC</li>
              <li className="text-cream/70">Online across BC</li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-8">
          <p className="text-sm text-cream/50">© {new Date().getFullYear()} {f.certLine}</p>
          <div className="flex items-center gap-4">
            <p className="text-sm text-cream/40">{f.madeLine}</p>
            <Link data-testid="footer-admin-link" to="/admin/login" className="text-xs text-cream/25 hover:text-cream/60 transition-colors duration-300">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
